/**
 * 분 단위 출고대기시간을 사용자 표시 포맷으로 변환
 * - 60의 배수 → '{H}H'      (예: 60 → '1H')
 * - 60 미만   → '{M}M'      (예: 10 → '10M')
 * - 그 외     → '{H}H {M}M' (예: 90 → '1H 30M')
 */
export const formatWaitTime = (minutes: number): string => {
  // 잘못된 값(0, 음수, NaN, Infinity) 방어 — 호출 사이트의 fallback과 일관되게 60분(=1H) 처리
  if (!Number.isFinite(minutes) || minutes < 1) return '1H'
  const safe = Math.floor(minutes)
  const h = Math.floor(safe / 60)
  const m = safe % 60
  if (h > 0 && m > 0) return `${h}H ${m}M`
  if (h > 0) return `${h}H`
  return `${m}M`
}
